import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const StudentDashboard = Loadable(lazy(() => import('./dashboard/StudentDashboard.jsx')));
const StudentAttandance = Loadable(lazy(() => import('./attandance/StudentAttandance.jsx')));
const StudentSettings = Loadable(lazy(() => import('./settings/StudentSettings.jsx')));

export const StudentDashboardRoutes = [
  { path: '/student/dashboard', element: <StudentDashboard /> },
  { path: '/student/attendance', element: <StudentAttandance /> },
  { path: '/student/settings', element: <StudentSettings /> },
];
